import styled from "styled-components";
import FlexBox, { FlexGrow } from "./../components/FlexBox";
import { Icon } from "@mui/material";
import Card from "./../components/Card";
import { StyledText, TextSize, TextStatus } from "./../components/Text";
import { RightAlign } from "./../components/UtilsComponents";
import NormalIcon from "./../components/Icon";
import moment from "moment";

const SkillCard = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: relative;
  width: auto;
  height: auto;
  min-height: 190px;
  left: 0px;
  top: 0px;

  /* Dark outline transparent */

  background: rgba(171, 171, 171, 0.1);
  // border: 2px solid #36eab9;
  // box-shadow: 0px 4px 35px #54c2ab;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  // flex: none;
  order: 0;
  // flex-grow: 0;
  // margin: 0px 20px;
  // cursor: pointer;
`;
type SkillModalProps = {
  selectedRow: any;
  setSkillView: any;
};
const Title = styled.div`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
`;
const StyledHr = styled.hr`
  width: 100%;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const Skills = ({
  selectedRow,
  setSkillView,
}: SkillModalProps): JSX.Element => {

  return (
    <div
      style={{
        borderRadius: 5,
      }}
    >
      <FlexBox justify="space-between">
        <Title>
          {" "}
          <Icon
            sx={{
              // color: "#ffff86",
              mr: 1,
              textShadow: "0 1px 5px black",
            }}
          >
            psychology
          </Icon>
          {/* {title} */}
          Skills
          <span
            style={{
              fontWeight: "normal",
              gap: 1,
              marginLeft: 5,
              display: "flex",
            }}
          >
            (
            <Icon
              title="Required to get competency credit"
              sx={{
                color: "yellow",
                // paddingRight: "1px",
                // boxShadow: "0 4px 4px #0000007a",
              }}
            >
              star
            </Icon>
            Required to get competency credit )
          </span>
        </Title>
        <FlexBox
          style={{
            color: "#ffda00",
            cursor: "pointer",
          }}
          onClick={() => setSkillView(false)}
        >
          <Icon>keyboard_double_arrow_left_icon</Icon>
          Back to Overview
        </FlexBox>
        {/* <ClickableIcon name="times" onClick={() => handleClose()} /> */}
      </FlexBox>
      <div
        className="visible-scrollbar"
        style={{
          display: "grid",
          //   gridTemplateColumns: "repeat(3, 1fr)",
          gap: 10,
          //   padding: "0px 10px",
          maxHeight: "65vh",
          overflow: "auto",
          margin: "20px 0px 0px 0px",
        }}
      >
        {selectedRow?.map((skill: any) => (
          <SkillCard
            style={{
              boxShadow: skill?.completed ? "0px 4px 35px #54c2ab30" : "",
              border: skill?.completed
                ? "0.1px solid #36eab9"
                : "1px solid #1d1c1c",
            }}
          >
            <div style={{ width: "100%" }}>
              <div>
                <StyledText textSize={TextSize.paragraph} fontWeight="700">
                  {skill.skill_code}
                </StyledText>
              </div>
              <FlexBox>
                {skill?.required && (
                  <FlexBox>
                    <Icon
                      title="Required to get competency credit"
                      sx={{
                        color: "yellow",
                        // paddingRight: "1px",
                        // boxShadow: "0 4px 4px #0000007a",
                      }}
                    >
                      star
                    </Icon>
                  </FlexBox>
                )}
                <StyledText textSize={TextSize.paragraph} fontWeight="600">
                  {skill.title}
                </StyledText>
                 <StyledText
                          status={TextStatus.muted}
                          // style={{ fontSize: "14px" }}
                          fontWeight="normal"
                        >
                          {skill.description}
                        </StyledText>
              </FlexBox>

              <ul>
                <li>
                  <div>
                    <StyledText
                      // status={TextStatus.warning}
                      style={{ fontWeight: "bold", color: "orange" }}
                    >
                      {/* <span style={{ color: "orange" }}>Assessment :</span>{" "} */}
                      {skill?.assessment?.title}
                    </StyledText>
                  </div>
                  <StyledText status={TextStatus.muted}>
                    {skill?.assessment?.description}
                  </StyledText>
                </li>
                {/* {skill?.topic_title && (
                  <li>
                    <div>
                      <StyledText
                        status={TextStatus.warning}
                        style={{ fontWeight: "bold" }}
                      >
                        <span style={{ color: "orange" }}>Topic :</span>{" "}
                        {skill?.topic_title}
                      </StyledText>
                    </div>
                    <StyledText status={TextStatus.muted}>
                      {skill?.topic_description}
                    </StyledText>
                  </li>
                )} */}
              </ul>
            </div>
            {skill.assessment &&
              skill.assessment.assessment_time &&
              skill.assessment.assessment_time !== "" && (
                <>
                  <FlexBox
                    style={{ borderTop: "1px solid white", marginTop: 15 }}
                  >
                    <div
                      style={{ position: "absolute", bottom: 10, right: 15 }}
                    >
                      <StyledText
                        textSize={TextSize.paragraph}
                        fontWeight="600"
                      >
                        Result: {skill?.assessment?.result}
                      </StyledText>
                    </div>
                  </FlexBox>
                </>
              )}
          </SkillCard>
        ))}
      </div>
    </div>
  );
};

export default Skills;
